import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=7cc4c277&scoped=true&"
import script from "./Name.vue?vue&type=script&lang=js&"
export * from "./Name.vue?vue&type=script&lang=js&"
import style0 from "./Name.vue?vue&type=style&index=0&id=7cc4c277&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc4c277",
  null
  
)

export default component.exports